import type { AlertConditionConfig } from "../services/delivery/alertCondition.types";

export const createAlertCondition = (
  id: string,
  overrides: Partial<Omit<AlertConditionConfig, "id">> = {},
): AlertConditionConfig => ({
  id,
  mode: "threshold",
  metric: null,
  comparator: null,
  threshold: "",
  ...overrides,
});

export const addAlertCondition = (
  conditions: AlertConditionConfig[],
  condition: AlertConditionConfig,
  maxConditions: number,
): AlertConditionConfig[] =>
  conditions.length >= maxConditions
    ? conditions
    : [...conditions, condition];

export const updateAlertCondition = (
  conditions: AlertConditionConfig[],
  conditionId: string,
  patch: Partial<Omit<AlertConditionConfig, "id">>,
): AlertConditionConfig[] => {
  const index = conditions.findIndex(({ id }) => id === conditionId);
  if (index === -1) return conditions;

  return conditions.map((condition, conditionIndex) =>
    conditionIndex === index ? { ...condition, ...patch } : condition,
  );
};

export const removeAlertCondition = (
  conditions: AlertConditionConfig[],
  conditionId: string,
): AlertConditionConfig[] => {
  if (conditions.length <= 1) return conditions;
  if (!conditions.some(({ id }) => id === conditionId)) return conditions;
  return conditions.filter(({ id }) => id !== conditionId);
};

export const isAlertConditionValid = (
  condition: AlertConditionConfig,
): boolean => {
  if (!condition.metric) return false;
  if (condition.mode === "auto") return true;

  return (
    Boolean(condition.comparator) && condition.threshold.trim().length > 0
  );
};

export const areAlertConditionsValid = (
  conditions: AlertConditionConfig[],
): boolean =>
  conditions.length > 0 && conditions.every(isAlertConditionValid);
